export default "__VITE_ASSET__DCi7SFd2__"